import React, { useState, useEffect } from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { connect } from "react-redux";
import { Field } from "react-final-form";
import { volunteerActions } from "../../state";
import { donationFormStyles } from "../donation/DonationForm.styles";
import { useThunkDispatch } from "../../hooks/useThunkDispatch";
import { required } from "../../lib/validators";
import classNames from "classnames";

function _VolunteerAutocomplete({
  isHomePage,
  campaign: {
    campaignId,
    enable_and_require_volunteer_selection_at_checkout,
    isActive,
    volunteer_label = "student",
  },
  authToken,
  forOrgIframe,
}) {
  const classes = donationFormStyles();
  const [showAC, setShowAC] = useState(false);
  const [options, setOptions] = useState([]);
  const dispatch = useThunkDispatch();

  useEffect(() => {
    if (
      campaignId &&
      (forOrgIframe ||
        (isHomePage &&
          enable_and_require_volunteer_selection_at_checkout &&
          isActive))
    )
      setShowAC(true);
  }, [
    campaignId,
    enable_and_require_volunteer_selection_at_checkout,
    isActive,
    forOrgIframe,
    isHomePage,
  ]);

  useEffect(() => {
    const fetchVolunteers = async () => {
      const data = await dispatch(
        volunteerActions.volunteerAutocomplete(campaignId, authToken),
      );
      if (data) setOptions(data);
    };

    if (showAC) fetchVolunteers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignId, authToken, showAC]);

  const isRequired = enable_and_require_volunteer_selection_at_checkout;

  if (!showAC) return <></>;
  return (
    <Field
      name="selectedVolunteerId"
      validate={isRequired ? required : undefined}
    >
      {({ input, meta }) => {
        const showError =
          (meta.error && meta.touched) || (meta.error && meta.submitFailed);

        return (
          <Autocomplete
            className={classNames(classes.input, classes.fullWidthInput)}
            getOptionLabel={({ name }) => name}
            options={options}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(_event, newValue) =>
              input.onChange(newValue ? newValue.id : null)
            }
            onBlur={input.onBlur}
            value={options.find(option => option.id === input.value) || null}
            renderInput={params => (
              <TextField
                {...params}
                label={`Select the ${volunteer_label} you are supporting`}
                required={isRequired}
                error={showError}
                helperText={showError ? meta.error : ""}
              />
            )}
          />
        );
      }}
    </Field>
  );
}

export const VolunteerAutocomplete = connect(state => {
  return { campaign: state.campaign };
})(_VolunteerAutocomplete);
